import Image from 'next/image'
import { founders } from '@/data/founders'

type FounderPhotoProps = {
  founder: (typeof founders)[number]
}

export function FounderPhoto({ founder }: FounderPhotoProps) {
  return (
    <div className="relative aspect-4/5 min-h-90 w-full overflow-hidden rounded-3xl bg-black-400 md:min-h-155">
      <Image
        src={founder.imageSrc}
        alt={founder.imageAlt}
        fill
        sizes="(min-width: 768px) 50vw, 100vw"
        className="object-cover"
      />
    </div>
  )
}
